import React, { useEffect, useMemo, useState } from "react";
import "../../styles/DashboardViewerModal.css";

export default function DashboardViewerModal({
  isOpen,
  onClose,
  dashboard,
  embedUrl,
  isLoading,
  expiresIn,
  onRefresh,
}) {
  const [secondsLeft, setSecondsLeft] = useState(null);

  const title = dashboard?.title || `Dashboard ${dashboard?.dashboard_id || ""}`;

  // countdown simple con expires_in
  const initialSeconds = useMemo(() => {
    if (!expiresIn) return null;
    const n = Number(expiresIn);
    return Number.isFinite(n) ? n : null;
  }, [expiresIn]);

  useEffect(() => {
    if (!isOpen) return;

    setSecondsLeft(initialSeconds);

    if (!initialSeconds) return;

    const t = setInterval(() => {
      setSecondsLeft((s) => (typeof s === "number" ? Math.max(0, s - 1) : s));
    }, 1000);

    return () => clearInterval(t);
  }, [isOpen, initialSeconds, dashboard?.dashboard_id]);

  if (!isOpen) return null;

  return (
    <div className="dvm-overlay" onMouseDown={onClose}>
      <div className="dvm-modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="dvm-header">
          <div className="dvm-title">
            <h3>{title}</h3>
            <div className="dvm-subtitle">
              {dashboard?.category ? <span>{dashboard.category}</span> : null}
              {typeof secondsLeft === "number" ? (
                <span className="dvm-expire">
                  Expira en {Math.floor(secondsLeft / 60)}:{String(secondsLeft % 60).padStart(2, "0")}
                </span>
              ) : null}
            </div>
          </div>

          <div className="dvm-actions">
            <button className="dvm-btn dvm-primary" onClick={onRefresh}>
              Refrescar
            </button>
            <button className="dvm-btn dvm-close" onClick={onClose}>
              ✕
            </button>
          </div>
        </div>

        <div className="dvm-body">
          {isLoading ? (
            <div className="dvm-loading">Cargando tablero…</div>
          ) : !embedUrl ? (
            <div className="dvm-empty">No se pudo obtener el acceso al tablero.</div>
          ) : (
            <div className="dvm-iframe-wrap">
              <iframe
                title={title}
                src={embedUrl}
                className="dvm-iframe"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
